export const FETCH_TOKEN_PENDING = 'FETCH_TOKEN_PENDING';
export const FETCH_TOKEN_SUCCESS = 'FETCH_TOKEN_SUCCESS';
export const FETCH_TOKEN_ERROR = 'FETCH_TOKEN_ERROR';

export function fetchTokenPending() {
    return {
        type: FETCH_TOKEN_PENDING
    }
}

export function fetchTokenSuccess(data) {
    return {
        type: FETCH_TOKEN_SUCCESS,
        result: data
    }
}

export function fetchTokenError(error) {
    return {
        type: FETCH_TOKEN_ERROR,
        error: error
    }
}
